import React, { useState } from 'react';
import HeartIcon from '../Icons/Heart/Heart';
import FeatherIconWrapper from '../Icons/FeatherIconWrapper';
import { LIKE_MUTATION } from './Queries/likeMutation'
import styled from "styled-components";
import { useMutation } from "@apollo/client";

/*
 *  @Description:   Component that renders a like icon with toggle on click.
 */

const TextSpan = styled.span`
    margin-left: 8px;
    cursor: pointer;
    @media (max-width: 1030px) {
        display: none;
    }
`;

const LikeIcon = ( props ) => {
    const {
        color,
        fillColor,
        width,
        activeStyle,
        unactiveStyle,
        likeId,
    } = props;
    const needsLegend = props.isResourceInformation && true
    const [ active, setActive ] = useState( props.active );
    const [ likeContent ] = useMutation( LIKE_MUTATION );

    const withLegendStyle = {
        margin: "15px 15px 0 0",
        display: "flex",
        alignItems: "flex-end",
        minHeight: "25px"
    }

    const toggleLike = ( itemId ) => {
        setActive( !active );
        likeContent( {
            variables: {
                input: {
                    id: itemId.toString(),
                    entity_type: "node"
                },
                update: ( store, { data: { likeContent } } ) => {
                    props.actionToChangeFav ?
                        props.actionToChangeFav( likeContent )
                        :
                        setActive( likeContent );
                }
            }
        } ).catch( error => console.error( error ) );
    }

    return (
        <span
            onClick={ (event) => {
                event.preventDefault();
                event.stopPropagation();
                toggleLike( likeId )
            } }
            style={ needsLegend ? withLegendStyle : {} }
        >
            <FeatherIconWrapper
                color={ color }
                fillColor={ fillColor }
                width={ width }
                iconStyle={ active ? activeStyle : unactiveStyle }
                Icon={ HeartIcon }
            />
            {
                needsLegend &&
                <>
                    { active ?
                        <TextSpan>Remove from favorites</TextSpan>
                        :
                        <TextSpan>Add to favorites</TextSpan>
                    }
                </>
            }
        </span>
    );
}

export default LikeIcon;